import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/portals")({
	component: PortalsLayout,
});

function PortalsLayout() {
	return <Outlet />;
}
